import { render } from "./training-type.vue?vue&type=template&id=4818af07"
import script from "./training-type.vue?vue&type=script&lang=js"
export * from "./training-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__